export default function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height
  }
}

// export const baseUrl = 'http://api.reachafrika-pay.local/api/v1/'
export const local = 'https://pay.reachafrika.com.ng/api/v1/'
export const staging = 'https://pay.reachafrika.com.ng/api/v1/'
export const production = 'https://pay.reachafrika.com/api/v1/'
const isLocal = window.location.hostname === 'localhost'
const isStaging = window.location.href.includes('.com.ng')
export const baseUrl = isLocal
  ? local
  : isStaging
    ? staging
    : production


// return options for select element
export const filterValues = ({ options, param, unifier = '', text }) => {
  let filtered = []
  const label = param.label.split(',')
  options.map(option => filtered = [...filtered, { label: `${option[label[0]]} ${unifier.split(',')[0] ?? ''}${option[label[1]] ?? ''}${option[text] ?? ''}${unifier.split(',')[1] ?? ''}`, value: option[param.value] }])
  return filtered
}

// return options for select element
export const formatValues = (options) => {
  let filtered = []
  options.map(option => filtered = [...filtered, { label: `${option.charAt(0).toUpperCase()}${option.slice(1)}`, value: option }])

  return filtered
}

// return options for select element
export const deepFilterValues = ({ options, param: { label, value, optional } }) => {
  let filtered = []
  const optionalValues = optional.split(',')
  options.map(option => filtered = [...filtered, { label: `${option[label]} (${option[optionalValues[0].split('.')[0]][optionalValues[0].split('.')[1]]} - ${option[optionalValues[1].split('.')[0]][optionalValues[1].split('.')[1]]})`, value: option[value] }])
  return filtered
}


export const changePage = ({ mutate, url, pageNumber }) => mutate(`${url}?page=${pageNumber}`)

export const getToken = () => localStorage.getItem('__ra_pos')

export const destructureErrorMessage = (message) => {
  if (message?.[0] === "{") {
    const messages = (JSON.parse(message)?.message)
    return Array.isArray(messages) ? messages : [messages]
  } else {
    if (message === 'Error: Network Error') return ['misc.network_error']
    return [message]
  }

  // if (`${(message)[0]}${(message)[(message).length - 1]}` === '{}') {
  //   for (const error of Object.values(JSON.parse(message))) {
  //     errorMessageBag = [...errorMessageBag, ...error]
  //   }
  // }
  // else if (message === 'network') errorMessageBag = ('misc.network_error')
  // else errorMessageBag = [message]


  // return errorMessageBag
}
export const formatAmount = (amount = 0, currency = 'NGN') => {
  const amt = new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency,
  }).format(isNaN(amount) ? 0 : amount)
  // if (isNaN(amt)) return 0
  return amt
}

export const capitalize = (string = '') => string ? string?.charAt(0).toUpperCase() + string.substring(1).toLowerCase() : ''